import { ObjectStorage } from "../ObjectStorage";

class SeedHistorySecureStorage extends ObjectStorage {
    public isSecure = true;
    public key = "seed_history";
}

export default SeedHistorySecureStorage.getInstance(SeedHistorySecureStorage);
